<template>
  <div class="w-100 py-3">
    <div class="mb-4 px-4" v-if="title || description">
      <h3 v-if="title" class="text-center font-weight-bold mb-3">
        {{ title }}
      </h3>
      <p
        v-if="description"
        class="text-justify mb-0"
        style="white-space: pre-line; line-height: 1.8"
      >
        {{ description }}
      </p>
    </div>
    <div class="catalog-container">
      <!-- 
      continuous: باعث می‌شود بعد از صفحه آخر، دوباره به صفحه اول برگردد و گیر نکند
      show-arrows-on-hover: فلش‌ها را زیباتر نمایش می‌دهد
      hide-delimiter-background: پس‌زمینه مزاحم نقطه‌ها را حذف می‌کند
    -->
      <v-carousel
        height="500"
        hide-delimiter-background
        show-arrows-on-hover
        continuous
        class="elevation-10 rounded-xl overflow-hidden"
      >
        <!-- 
        استفاده از افکت لغزشی (Slide) به جای محو شدن (Fade) 
        برای اینکه حس ورق زدن (کشیدن با دست) را در موبایل بهتر القا کند
      -->
        <v-carousel-item
          v-for="(item, i) in value"
          :key="i"
          :src="item.url"
          transition="slide-x-transition"
          reverse-transition="slide-x-reverse-transition"
        >
          <v-row class="fill-height pb-6" align="end" justify="center">
            <v-chip color="rgba(0, 0, 0, 0.6)" text-color="white" small>
              صفحه {{ persian(i + 1) }} از {{ persian(value.length) }}
            </v-chip>
          </v-row>
        </v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "catalogSwiper",
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
  },
};
</script>

<style scoped>
.catalog-container {
  padding: 10px;
  max-width: 450px;
  margin: 0 auto;
}
</style>
